"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var components_1 = require("@/components");
var Styled = __importStar(require("./ApplicationFormSection.styled"));
var constants_1 = require("@/constants");
var hooks_1 = require("@/hooks");
var ApplicationFormSection = function (_a) {
    var headline = _a.headline;
    var handleGoBack = (0, hooks_1.useHistory)().handleGoBack;
    return ((0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)(components_1.BackButton, { label: "\uBAA9\uB85D \uB3CC\uC544\uAC00\uAE30", onClick: function () { return handleGoBack(constants_1.PATH.APPLICATION_FORM); } }, void 0), (0, jsx_runtime_1.jsx)(Styled.Headline, { children: headline }, void 0)] }, void 0));
};
exports.default = ApplicationFormSection;
